<div class="w-full flex items-center justify-center py-20">
    <!-- <img src="../../../assets/images/websitev2/dashcam-installation-thumbnail.png" alt=""> -->
    <!-- <div class="w-[20rem] h-[12rem] bg-white rounded-lg flex items-center justify-center h-10 w-15 border border-gray-500 cursor-pointer"
        title="Comming soon">
        <i class="bx bx-play-circle hover:text-red-600 text-[35px]" title="Comming soon"></i>
    </div> -->
   <div class="video-container">
    <iframe
        src="https://www.youtube.com/embed/2h3_ZDnwUdo?rel=0&modestbranding=1&playsinline=1"
        title="Video"
        loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen>
    </iframe>
</div>
</div>

<div class="flex flex-col items-center">
    <div class="mx-10 flex flex-col gap-2">
        <div class="flex gap-2 items-baseline">
            <i class="bx bx-chevron-right-circle"></i>
            <span>Mount the dashcam on the front and rear windshields.</span>
        </div>
        <div class="flex gap-2 items-baseline">
            <i class="bx bx-chevron-right-circle"></i>
            <span>Insert the memory card into the dashcam.</span>
        </div>
        <div class="flex gap-2 items-baseline">
            <i class="bx bx-chevron-right-circle"></i>
            <span>Route the power cable along the windshield edges.</span>
        </div>
        <div class="flex gap-2 items-baseline">
            <i class="bx bx-chevron-right-circle"></i>
            <span>Connect the cable to the car's 12V or USB port.</span>
        </div>
        <div class="flex gap-2 items-baseline">
            <i class="bx bx-chevron-right-circle"></i>
            <span>Adjust the camera angle for a clear road view.</span>
        </div>
        <div class="flex gap-2 items-baseline">
            <i class="bx bx-chevron-right-circle"></i>
            <span>Start the car to power on the dashcam.</span>
        </div>
        <div class="flex gap-2 items-baseline">
            <i class="bx bx-chevron-right-circle"></i>
            <span>Connect to the Varroc Connect app via Wi-Fi to finish setup.</span>
        </div>
    </div>
</div>